import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Building2, XCircle, RefreshCw, Mail } from 'lucide-react';

const PaymentFailure = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const { error, planId, email } = location.state || {};

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-50 via-cyan-50 to-orange-50 p-4">
      <div className="w-full max-w-2xl">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-2xl mb-4 shadow-lg">
            <Building2 className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-4xl font-bold bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent">
            MyVenueMate
          </h1>
        </div>

        <Card className="shadow-xl border-0 border-t-4 border-t-red-500">
          <CardContent className="pt-8 pb-8 text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-red-100 dark:bg-red-900/30 rounded-full mb-6">
              <XCircle className="w-10 h-10 text-red-600" />
            </div>
            
            <h2 className="text-2xl font-bold text-gray-900 dark:text-foreground mb-4">
              Payment Failed
            </h2>
            
            <p className="text-gray-600 dark:text-muted-foreground mb-6 max-w-md mx-auto">
              {error || 'We were unable to process your payment. Please try again or contact support if the issue persists.'}
            </p>

            <div className="space-y-3 mb-6">
              <Card className="bg-orange-50 dark:bg-orange-900/20 border-orange-200">
                <CardContent className="pt-4 pb-4">
                  <div className="flex items-start space-x-3 text-left">
                    <Mail className="w-5 h-5 text-orange-600 mt-0.5" />
                    <div>
                      <h3 className="font-semibold text-gray-900 dark:text-foreground text-sm mb-1">Need Help?</h3>
                      <p className="text-xs text-gray-700 dark:text-foreground">
                        If you&apos;re facing issues with payment, please contact us at{' '}
                        <a href="mailto:info@myvenuemate.in" className="text-teal-600 font-semibold underline">
                          info@myvenuemate.in
                        </a>
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-blue-50 dark:bg-blue-900/20 border-blue-200">
                <CardContent className="pt-4 pb-4">
                  <div className="text-left">
                    <h3 className="font-semibold text-gray-900 dark:text-foreground text-sm mb-2">Common Issues:</h3>
                    <ul className="text-xs text-gray-700 dark:text-foreground space-y-1 list-disc list-inside">
                      <li>Insufficient balance in your account</li>
                      <li>Incorrect payment details entered</li>
                      <li>Network connectivity issues</li>
                      <li>Bank declined the transaction</li>
                    </ul>
                  </div>
                </CardContent>
              </Card>
            </div>

            <div className="flex gap-3">
              <Button
                variant="outline"
                onClick={() => navigate('/choose-plan')}
                className="flex-1"
              >
                Choose Different Plan
              </Button>
              <Button
                onClick={() => navigate('/payment', { state: { email, planId } })}
                className="flex-1 bg-gradient-to-r from-teal-500 to-cyan-600 hover:from-teal-600 hover:to-cyan-700"
              >
                <RefreshCw className="w-4 h-4 mr-2" />
                Try Again
              </Button>
            </div>
          </CardContent>
        </Card>

        <div className="mt-8 text-center">
          <p className="text-xs text-gray-500 dark:text-muted-foreground">
            Powered by <span className="font-semibold text-teal-600">MYONK</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailure;
